export default "__VITE_ASSET__0c505567__"